import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    br: {
      paddingBottom: theme.spacing(1),
    },
  })
);
